<script>
  export let title
  export let fontSize = 14
</script>

<style>
  :global(.kb-neptune-widget-title-2-TP2P) {
    font-weight: 600;
    margin: 25px 0 10px;
  }
</style>

<div class="kb-neptune-widget-title-2-TP2P" style={`font-size: ${fontSize}px;`}>
  {title !== undefined ? title : ''}
</div>
